/**
 * Tab Content Section - Tab 切换和图片懒加载
 */

function syncTabContentSectionTabStops(sectionElement) {
  sectionElement.querySelectorAll(".tab-content-section__tab").forEach((tab) => {
    tab.setAttribute("type", "button");
    tab.setAttribute("tabindex", "0");
  });
}

function bindTabContentSectionTabFocus(tab, handler) {
  tab.addEventListener("focusin", handler);
  tab.addEventListener("focus", handler);
}

function initTabContentSection(sectionElement) {
  const tabs = sectionElement.querySelectorAll(".tab-content-section__tab");
  const contents = sectionElement.querySelectorAll(".tab-content-section__content");

  if (tabs.length === 0 || contents.length === 0) return;

  syncTabContentSectionTabStops(sectionElement);

  // 切换 tab 和内容
  function switchTab(tabIndex) {
    // 移除所有激活状态
    tabs.forEach((tab, index) => {
      if (index === tabIndex) {
        tab.classList.add("is-active");
        tab.setAttribute("aria-selected", "true");
      } else {
        tab.classList.remove("is-active");
        tab.setAttribute("aria-selected", "false");
      }
    });

    // 切换内容显示
    contents.forEach((content, index) => {
      if (index === tabIndex) {
        // 延迟显示以支持过渡动画
        requestAnimationFrame(() => {
          content.classList.add("is-active");
        });
        // 懒加载图片
        loadImagesInContent(content);
        // 处理视频播放
        playVideosInContent(content);
      } else {
        content.classList.remove("is-active");
        // 暂停非激活内容中的视频
        pauseVideosInContent(content);
      }
    });

    syncTabContentSectionTabStops(sectionElement);
  }

  // 懒加载内容中的图片
  function loadImagesInContent(contentElement) {
    const images = contentElement.querySelectorAll('img[loading="lazy"]');
    images.forEach((img) => {
      if (!img.complete || img.naturalWidth === 0) {
        // 图片还未加载，触发加载
        const src = img.src;
        if (src) {
          const tempImg = new Image();
          tempImg.onload = () => {
            img.src = src;
          };
          tempImg.src = src;
        }
      }
    });
  }

  // 播放内容中的视频
  function playVideosInContent(contentElement) {
    const videos = contentElement.querySelectorAll("video");
    videos.forEach((video) => {
      // 重置视频到开始位置并播放
      video.currentTime = 0;
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          // 自动播放失败时静默处理（浏览器策略限制）
          //console.log("Video autoplay failed:", error);
        });
      }
    });
  }

  // 暂停内容中的视频
  function pauseVideosInContent(contentElement) {
    const videos = contentElement.querySelectorAll("video");
    videos.forEach((video) => {
      video.pause();
    });
  }

  // 绑定点击事件
  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      switchTab(index);
    });
    bindTabContentSectionTabFocus(tab, () => {
      if (!tab.classList.contains("is-active")) {
        switchTab(index);
      }
    });
  });

  // 键盘导航支持
  tabs.forEach((tab, index) => {
    tab.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        switchTab(index);
      } else if (e.key === "ArrowRight") {
        e.preventDefault();
        const nextIndex = (index + 1) % tabs.length;
        tabs[nextIndex].focus();
        switchTab(nextIndex);
      } else if (e.key === "ArrowLeft") {
        e.preventDefault();
        const prevIndex = (index - 1 + tabs.length) % tabs.length;
        tabs[prevIndex].focus();
        switchTab(prevIndex);
      }
    });
  });

  // 初始化：加载第一个内容的图片和视频
  const firstContent = contents[0];
  if (firstContent) {
    loadImagesInContent(firstContent);
    playVideosInContent(firstContent);
  }
}

// 初始化所有 tab-content-section
function initAllTabContentSections() {
  document.querySelectorAll(".tab-content-section").forEach((section) => {
    initTabContentSection(section);
  });
}

// DOM 加载完成后初始化
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAllTabContentSections);
} else {
  initAllTabContentSections();
}

// Shopify 主题编辑器支持
document.addEventListener("shopify:section:load", (event) => {
  const section = event.target.querySelector(".tab-content-section");
  if (section) {
    initTabContentSection(section);
  }
});
